import { render, staticRenderFns } from "./activityRecommended.vue?vue&type=template&id=540b12e3&scoped=true"
import script from "./activityRecommended.vue?vue&type=script&lang=js"
export * from "./activityRecommended.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540b12e3",
  null
  
)

export default component.exports